export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4746.50144b48.jpg";